import { WOW } from "wowjs"
window.WOW = WOW
